import { ProviderType } from "../../../services/cloudchipr.api";
import { PROVIDERS } from "../../constants/providers";

export const isStringProviderType = (str: string): str is ProviderType => {
  return PROVIDERS.includes(str as ProviderType);
};
